import * as React from 'react';

const ERPCancelButton = ({
	disabled,
	children,
	type,
	onClick,
}: {
	disabled?: boolean;
	loading?: boolean;
	children?: React.ReactNode;
	type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
	onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
}) => {
	return (
		<button className='btn-text' disabled={disabled} type={type || 'button'} onClick={onClick}>
			<svg
				className='inline-block relative -mt-0.5 h-4 w-4'
				fill='none'
				stroke='currentColor'
				strokeWidth='2'
				viewBox='0 0 24 24'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path d='M6 18L18 6M6 6l12 12' strokeLinecap='round' strokeLinejoin='round'></path>
			</svg>
			&nbsp;{children}
		</button>
	);
};

export default React.memo(ERPCancelButton);
